import { Model } from "./Model";
import { required } from "vuelidate/lib/validators";

class Estado extends Model {
  constructor() {
    super();
    this.uf = "";
  }
}

const EstadoValidation = {
  uf: {
    required,
  },
};

const EstadoNoValidation = {
  uf: {},
};

export { Estado, EstadoValidation, EstadoNoValidation };
